import { render, staticRenderFns } from "./ActiveCustomers.vue?vue&type=template&id=17d3f2da&scoped=true&"
import script from "./ActiveCustomers.vue?vue&type=script&lang=js&"
export * from "./ActiveCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCustomers.vue?vue&type=style&index=0&id=17d3f2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3f2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VContainer,VDataTable,VIcon,VTextField,VTooltip})
